export const PAGE_SIZE = 10;

export enum ProjectTypeAccessorKey {
  carbonStorageAg = 'carbonStorageAg',
  carbonStorageBg = 'carbonStorageBg',
  waterHoldingCapacity = 'waterHoldingCapacity',
  canopyHeight = 'canopyHeight',
  canopyCover = 'canopyCover',
  biodiversityZone = 'biodiversityZone',
}
